import {
  FETCH_TASKS,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILED,
  ACCEPT_TASK,
  CANCEL_TASK,
} from "../store/types";
import store from "../store/store";
import { updateProfile } from "./authactions";
import { RequestPushMsg } from "../other/NotificationFunctions";
import { firebase } from '../config/configureFirebase';
import { onValue, runTransaction, get, off, push } from "firebase/database";
import {driverQueue} from '../other/sharedFunctions';

export const fetchTasks = () => (dispatch) => {
  const { auth, tasksRef } = firebase;

  const uid = auth.currentUser.uid;
  off(tasksRef());
  dispatch({
    type: FETCH_TASKS,
    payload: null,
  });
  onValue(tasksRef(), (snapshot) => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data)
        .filter(
          (i) => data[i].requestedDrivers && data[i].requestedDrivers[uid]
        )
        .filter((i) => {
          const customerId = data[i].customer;
          const blockedMap = store.getState().userblockdata?.map || {};
          return !customerId || !blockedMap[customerId];
        })
        .map((i) => {
          data[i].id = i;
          const est = data[i].driverEstimates && data[i].driverEstimates[uid];
          if (est && est.distance != null && data[i].estimateDistance == null) {
            data[i].estimateDistance = est.distance;
          }
          if (est && est.timein_text && !data[i].estimateTime) {
            data[i].estimateTime = est.timein_text;
          }
          return data[i];
        });
      dispatch({
        type: FETCH_TASKS_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: FETCH_TASKS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_tasks,
      });
    }
  });
};

export const acceptTask = (task) => (dispatch) => {
  const { auth, trackingRef, singleUserRef, singleBookingRef, walletHistoryRef, settingsRef } = firebase;

  const uid = auth.currentUser.uid;
  const blockedMap = store.getState().userblockdata?.map || {};
  if (task?.customer && blockedMap[task.customer]) {
    dispatch(cancelTask(task.id));
    return;
  }

  onValue(singleUserRef(uid), (snapshot) => {
    let profile = snapshot.val();

    runTransaction(singleBookingRef(task.id),(booking) => {
      let fleetCommission_fee= profile?.fleetadmin ? ((parseFloat(booking?.estimate) - parseFloat(booking?.convenience_fees)) * parseFloat(booking?.fleet_admin_comission) / 100).toFixed(2):0;
      let driver_fee = parseFloat(parseFloat(booking?.estimate) - (parseFloat(booking?.convenience_fees) + parseFloat(fleetCommission_fee) )).toFixed(2);
        if (booking && booking.requestedDrivers) {
          booking.driver = uid;
          booking.driver_image = profile.profile_image ? profile.profile_image : "";
          booking.driver_face = profile.faceImage ? profile.faceImage : "";
          booking.car_image =  profile.car_image ? profile.car_image : "";
          booking.driver_name = profile.firstName + " " + profile.lastName;
          booking.driver_contact = profile.mobile;
          booking.driver_token = profile.pushToken ? profile.pushToken : '';
          booking.vehicle_number = profile.vehicleNumber ? profile.vehicleNumber : "";
          booking.vehicleModel = profile.vehicleModel ? profile.vehicleModel : "";
          booking.vehicleMake = profile.vehicleMake ? profile.vehicleMake : "";
          booking.driverRating = profile.rating ? profile.rating : "0";
          booking.fleetCommission= fleetCommission_fee? fleetCommission_fee : "0"
          booking.fleetadmin = profile.fleetadmin ? profile.fleetadmin : "";
          booking.status = "ACCEPTED";
          // Sello de aceptación para la ventana de gracia antifraude (#13).
          booking.acceptedAt = Date.now();
          booking.driver_share = driver_fee? driver_fee : "0";
          booking.driverDeviceId = task.driverDeviceId? task.driverDeviceId: null;
          booking.requestedDrivers = null;
          booking.driverEstimates = null;
          return booking;
        }
      })
      .then(() => {
        get(singleBookingRef(task.id))
          .then((snapshot) => {
            if (!snapshot.exists()) {
              return;
            } else {
              let requestedDrivers =
                snapshot.val() && snapshot.val().requestedDrivers;
              let driverId = snapshot.val() && snapshot.val().driver;

              if (requestedDrivers == undefined && driverId === uid) {
                updateProfile({ queue: driverQueue ? false : true })(dispatch);

                // Publicidad: si el conductor tiene saldo de publicidad, se le
                // descuenta el costo por servicio (clic). Se hace con transacción
                // atómica para evitar doble gasto si acepta dos viajes casi a la vez.
                (async () => {
                  try {
                    const settingsSnap = await get(settingsRef);
                    const adSettings = settingsSnap.val() || {};
                    if (adSettings.internal_ad_enabled === false) return;
                    const clickCost = adSettings.ad_click_cost != null ? parseFloat(adSettings.ad_click_cost) : 10000;
                    const decimal = adSettings.decimal != null ? adSettings.decimal : 2;
                    if (!(clickCost > 0)) return;
                    let deducted = false;
                    const txRes = await runTransaction(singleUserRef(uid), (user) => {
                      if (!user) return user;
                      const bal = parseFloat(user.adBalance || 0);
                      if (bal >= clickCost) {
                        user.adBalance = parseFloat((bal - clickCost).toFixed(decimal));
                        user.adActive = user.adBalance >= clickCost;
                        deducted = true;
                      } else {
                        deducted = false;
                      }
                      return user;
                    });
                    if (txRes && txRes.committed && deducted) {
                      await push(walletHistoryRef(uid), {
                        type: 'Debit',
                        amount: clickCost,
                        date: new Date().getTime(),
                        txRef: 'AdClick'
                      });
                    }
                  } catch (e) { /* no bloquea la aceptación del viaje */ }
                })();

                const driverFullName = (profile.firstName || '') + (profile.lastName ? ' ' + profile.lastName : '');
                RequestPushMsg(task.customer_token, {
                  title:
                    store.getState().languagedata.defaultLanguage
                      .notification_title,
                  msg:
                   (driverFullName.trim() || profile.firstName) +
                    store.getState().languagedata.defaultLanguage
                      .accept_booking_request,
                  screen: "BookedCab",
                  params: { bookingId: task.id },
                });

                const driverLocation = store.getState().gpsdata.location;

                if (driverLocation && driverLocation.lat != null && driverLocation.lng != null) {
                  push(trackingRef(task.id), {
                    at: new Date().getTime(),
                    status: "ACCEPTED",
                    lat: driverLocation.lat,
                    lng: driverLocation.lng,
                  }).catch((e) => { console.log('tracking push error', e); });
                }

                dispatch({
                  type: ACCEPT_TASK,
                  payload: { task: task },
                });
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      })
      // Si la transacción de aceptación falla (p. ej. PERMISSION_DENIED o
      // reintentos agotados), evitamos el rechazo no manejado que mostraba la
      // caja roja "Operación no completada" y dejaba el viaje sin aceptar.
      .catch((error) => {
        console.log('acceptTask transaction error', error);
        dispatch({
          type: FETCH_TASKS_FAILED,
          payload: (error && (error.message || error.toString())) || "Accept task error",
        });
      });
  },{onlyOnce:true});
};

export const cancelTask = (bookingId) => (dispatch) => {
  const { auth, singleBookingRef } = firebase;

  const uid = auth.currentUser.uid;

  runTransaction(singleBookingRef(bookingId), (booking) => {
      if (booking && booking.requestedDrivers && booking.requestedDrivers[uid]) {
        if (!booking.rejectedDrivers) {
          booking.rejectedDrivers = {};
        }
        booking.rejectedDrivers[uid] = true;
        delete booking.requestedDrivers[uid];
        // Conservar driverEstimates para re-ofertar al socio más cercano si no hay alternativas.
        if (booking.driverOffers && booking.driverOffers[uid]) {
          delete booking.driverOffers[uid];
        }
        if (booking.selectedBid && booking.selectedBid.driver === uid) {
          delete booking.selectedBid;
        }
        booking.status = "NEW";
        booking.dispatchRedispatchAt = Date.now();
        dispatch({
          type: CANCEL_TASK,
          payload: { uid: uid, bookingId: bookingId },
        });
        return booking;
      }
      return booking;
    }).catch((error) => {
      // Evita el rechazo no manejado (caja roja PERMISSION_DENIED) al cancelar.
      console.log('cancelTask transaction error', error);
    });
};
